export default {"src":"/_next/static/media/404.b8284180.gif","height":500,"width":800,"blurWidth":0,"blurHeight":0};